<template>
  <fieldset
    class="service-samples mt-2 w-100">
    <legend class="d-flex mt-2 mb-2">
      <span>
        {{ $t('service.samples.title') }}
      </span>

      <d-button
        v-if="!readOnly && isIndent"
        theme="success"
        size="sm"
        :outline="true"
        class="ml-auto"
        @click.prevent="addSample()">
        {{ $t('service.samples.add') }}
      </d-button>
    </legend>

    <d-alert
      v-if="!serviceData.samples || !serviceData.samples.length"
      show
      theme="light"
      class="text-center mb-0">
      {{ $t('service.samples.noSamples') }}
    </d-alert>

    <ul
      class="service-samples-list">
      <li
        v-for="(sample, index) of serviceData.samples"
        :key="'service-samples-list-item-' + index">
        <strong class="pt-1 ">
          {{ $t('service.samples.sample') }} #{{ index + 1 }}
        </strong>

        <label
          v-if="isIndent"
          class="d-block ml-auto">
          <d-button-group
            size="small">
            <d-button
              :theme="sample.status === 'APPROVED' ? 'success' : 'secondary'"
              :outline="sample.status !== 'APPROVED'"
              :disabled="readOnly"
              size="sm"
              @click.prevent="setSampleStatus(index, 'APPROVED')">
              {{ $t('service.samples.statuses.accepted') }}
            </d-button>
            <d-button
              :theme="sample.status === 'REJECTED' ? 'danger' : 'secondary'"
              :outline="sample.status !== 'REJECTED'"
              :disabled="readOnly"
              size="sm"
              @click.prevent="setSampleStatus(index, 'REJECTED')">
              {{ $t('service.samples.statuses.rejected') }}
            </d-button>
          </d-button-group>
        </label>
        <label
          v-else
          class="d-block pt-1 pl-3">
          <span
            v-if="!isIndent && sample.status === 'APPROVED'"
            class="text-success">
            {{ $t('service.samples.statuses.accepted') }}
          </span>
          <span
            v-if="!isIndent && sample.status === 'REJECTED'"
            class="text-danger">
            {{ $t('service.samples.statuses.rejected') }}
          </span>
        </label>

        <d-button
          v-if="sample.id"
          theme="primary"
          size="sm"
          class="ml-auto w-25"
          @click.prevent="toggleSampleFilesList(sample.id)">
          <template v-if="visibleFilesList === sample.id">
            {{ $t('service.samples.hideFiles', { count: sample.images.length }) }}
          </template>
          <template v-else>
            {{ $t('service.samples.showFiles', { count: sample.images.length }) }}
          </template>
        </d-button>

        <small
          v-else
          class="text-warning w-25 ml-auto">
          {{ $t('service.samples.saveBeforeAddingFiles') }}
        </small>

        <label
          v-if="sample.status === 'REJECTED'"
          class="d-block w-100 mt-2 mb-4">
          <div class="d-flex">
            <small class="d-inline-block">
              {{ $t('service.samples.rejectReason') }}:
            </small>

            <small class="d-inline-block ml-auto pb-1">
              <a
                :href="sample.dropbox_catalog"
                target="_blank"
                rel="noreferrer noopener">
                <i class="material-icons" style="position: relative; top:3px;">folder</i> {{ $t('service.dropboxCatalog') }}
              </a>
            </small>
          </div>

          <d-textarea
            :value.prop="sample.reject_reason"
            v-model="sample.reject_reason"
            :disabled="readOnly">
          </d-textarea>
        </label>

        <order-creator-service-sample-files
          v-if="visibleFilesList === sample.id"
          :sampleID="sample.id"
          :sampleFiles="sample.images"
          :readOnly="readOnly" />
      </li>
    </ul>
  </fieldset>
</template>

<script>
import Vue from 'vue';
import OrderCreatorServiceSampleFiles from './OrderCreatorServiceSampleFiles.vue';

export default {
  name: 'order-creator-service-samples',
  props: [
    'isIndent',
    'readOnly',
    'serviceData'
  ],
  components: {
    'order-creator-service-sample-files': OrderCreatorServiceSampleFiles
  },
  data () {
    return {
      visibleFilesList: null
    };
  },
  methods: {
    addSample () {
      this.serviceData.samples.push({
        status: null,
        reject_reason: ''
      });
    },
    setSampleStatus (index, newStatus) {
      Vue.set(this.serviceData.samples[index], 'status', newStatus);
    },
    toggleSampleFilesList(sampleID) {
      if (this.visibleFilesList !== sampleID) {
        this.visibleFilesList = sampleID;
      } else {
        this.visibleFilesList = null;
      }
    }
  }
}
</script>

<style lang="scss">
.service-samples {
  border: 1px solid #ddd;
  padding: 10px;

  legend {
    padding: 0 10px;
  }

  legend > span {
    font-size: 16px;
  }

  &-list {
    list-style-type: none;
    margin-bottom: 0;
    padding: 0;

    li {
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;

      &:first-child {
        margin-top: 0;
      }

      label {
        margin-bottom: 0;
      }
    }
  }
}
</style>
